import { configure, defineRule } from 'vee-validate';
import { required, email, confirmed } from '@vee-validate/rules';

// Define validation rules
defineRule('required', required);
defineRule('email', email);  
defineRule('confirmed', confirmed);

// Configure validation
configure({
  generateMessage: ({ field, rule }) => {
    const messages = {
      required: `${field} is required.`,
      email: `${field} must be a valid email address.`,
      confirmed: `${field} confirmation does not match.`,
    };
    return messages[rule.name] || `${field} is invalid.`;
  },
  validateOnBlur: true,
  validateOnChange: true,
  validateOnInput: false,
  validateOnModelUpdate: true,
});